<main class="invoice-page" aria-labelledby="invoice-page-title">
  <button mat-stroked-button type="button" class="back-button" (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>{{ "jobs_awaiting_invoice_back" | translate }}
  </button>

  <header class="invoice-page__header">
    <h1 id="invoice-page-title">{{ "jobs_awaiting_invoice_title" | translate }}</h1>
  </header>

  <app-information-panel
    [title]="'jobs_awaiting_invoice_information' | translate"
    [description]="'jobs_awaiting_invoice_information_text' | translate">
  </app-information-panel>

  <section class="invoice-filters" [attr.aria-label]="'jobs_awaiting_invoice_filters' | translate">
    <h2><mat-icon>filter_alt</mat-icon>{{ "jobs_awaiting_invoice_filters" | translate }}</h2>
    <div class="invoice-filters__fields">
      <mat-form-field appearance="outline">
        <mat-label>{{ "jobs_awaiting_invoice_job_type" | translate }}</mat-label>
        <mat-select [(ngModel)]="filters.jobType">
          <mat-option value="">{{ "jobs_awaiting_invoice_any" | translate }}</mat-option>
          @for (jobType of jobTypes; track jobType) { <mat-option [value]="jobType">{{ jobType }}</mat-option> }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ "jobs_awaiting_invoice_job_number" | translate }}</mat-label>
        <input matInput type="search" [(ngModel)]="filters.jobNumber" (keyup.enter)="applyFilters()" [placeholder]="'jobs_awaiting_invoice_job_number_placeholder' | translate">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ "jobs_awaiting_invoice_site_name" | translate }}</mat-label>
        <mat-select [(ngModel)]="filters.siteName">
          <mat-option value="">{{ "jobs_awaiting_invoice_any" | translate }}</mat-option>
          @for (siteName of siteNames; track siteName) { <mat-option [value]="siteName">{{ siteName }}</mat-option> }
        </mat-select>
      </mat-form-field>

      <button mat-raised-button type="button" class="apply-button" (click)="applyFilters()">
        <mat-icon>search</mat-icon>{{ "jobs_awaiting_invoice_apply" | translate }}
      </button>
    </div>
  </section>

  @if (hasLoadError) {
    <div class="invoice-state invoice-state--error" role="alert">{{ "jobs_awaiting_invoice_load_error" | translate }}</div>
  } @else if (!hasLoaded) {
    <div class="invoice-state"><mat-spinner diameter="36"></mat-spinner></div>
  } @else if (filteredJobs.length === 0) {
    <div class="invoice-state">{{ "jobs_awaiting_invoice_empty" | translate }}</div>
  } @else {
    <section class="invoice-table-wrap" [attr.aria-label]="'jobs_awaiting_invoice_results' | translate">
      <table class="invoice-table">
        <thead><tr>
          <th>{{ "jobs_awaiting_invoice_status" | translate }}</th>
          <th>{{ "jobs_awaiting_invoice_job_type" | translate }}</th>
          <th>{{ "jobs_awaiting_invoice_job_number" | translate }}</th>
          <th>{{ "jobs_awaiting_invoice_site_name" | translate }}</th>
          <th>{{ "jobs_awaiting_invoice_po_numbers" | translate }}</th>
          <th><span class="visually-hidden">{{ "jobs_awaiting_invoice_actions" | translate }}</span></th>
        </tr></thead>
        <tbody>
          @for (job of pagedJobs; track job.id) {
            <tr>
              <td><span class="status-badge">{{ "jobs_awaiting_invoice_awaiting" | translate }}</span></td>
              <td>{{ job.jobType || '-' }}</td>
              <td>{{ jobNumber(job) }}</td>
              <td>{{ job.site?.name || '-' }}</td>
              <td>{{ purchaseOrderNumbers(job) }}</td>
              <td class="invoice-actions"><button mat-stroked-button type="button" (click)="submitInvoice(job)">{{ "jobs_awaiting_invoice_submit" | translate }}</button></td>
            </tr>
          }
        </tbody>
      </table>
    </section>

    <section class="invoice-cards" [attr.aria-label]="'jobs_awaiting_invoice_results' | translate">
      @for (job of pagedJobs; track job.id) {
        <article class="invoice-card">
          <header><strong>{{ jobNumber(job) }}</strong><span class="status-badge">{{ "jobs_awaiting_invoice_awaiting" | translate }}</span></header>
          <dl>
            <div><dt>{{ "jobs_awaiting_invoice_job_type" | translate }}</dt><dd>{{ job.jobType || '-' }}</dd></div>
            <div><dt>{{ "jobs_awaiting_invoice_site_name" | translate }}</dt><dd>{{ job.site?.name || '-' }}</dd></div>
            <div><dt>{{ "jobs_awaiting_invoice_po_numbers" | translate }}</dt><dd>{{ purchaseOrderNumbers(job) }}</dd></div>
          </dl>
          <button mat-stroked-button type="button" (click)="submitInvoice(job)">{{ "jobs_awaiting_invoice_submit" | translate }}</button>
        </article>
      }
    </section>

    <mat-paginator [length]="filteredJobs.length" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons (page)="changePage($event)"></mat-paginator>
  }
</main>